module.exports = __webpack_public_path__ + "img/shuibiaojiankong.fb2e15e3.svg";